<div class="player" #playerEl (click)="loadVideoFrame()" [ngClass]="{ 'player-error': videoError }">
    <div class="thumbnail-wrapper" *ngIf="!loadIFrame || !showVideoFrame" @fadeIn>
        <button *ngIf="!autoplay" class="play-button" type="button">
            <span class="kk-visuallyhidden">{{ 'general.action.play' | translateSafe }}</span>
            <app-svg-icon iconName="play" class="play-icon" *ngIf="!showVideoFrame && !loadIFrame"></app-svg-icon>
        </button>

        <div class="player-error-message" *ngIf="videoError">
            {{ videoError }}
        </div>

        <app-image
            class="thumbnail"
            *ngIf="!showVideoFrame && thumbnail"
            [image]="thumbnail"
            [width]="1400"
            [height]="787"
            [style]="{ height: '100%', objectFit: 'cover' }"
            crop="crop"
        ></app-image>
        <button
            class="consent-disclaimer"
            *ngIf="showConsentDisclaimer"
            (click)="cookieConsentService.openCookieConsentPopup()"
        >
            <span>
                {{
                    'cookieConsent.youtube'
                        | translate
                        | formatString: { category: ('cookieConsent.statistic' | translate) }
                }}
                <br />
                {{ 'cookieConsent.changeConsent' | translate }}
            </span>
        </button>
    </div>
    <div class="video-player" #videoWrapperEl>
        <div [hidden]="!showVideoFrame" #videoEl></div>
    </div>
</div>
<caption class="caption" *ngIf="caption" [innerHTML]="caption | safe: 'html'"></caption>
